<template>
  <div class="apps-container">
    <div
      class="order_detail_main"
      v-loading="Loading"
      v-if="appDetail"
      style="padding: 0"
    >
      <div class="info_box">
        <div class="tit">
          <el-col :span="4">{{ appDetail.appName }}</el-col>
          <el-col
            :span="20"
            style="text-align: right"
            v-if="appDetail.status != 'released'"
          >
            <el-button
              style="margin-right: 10px"
              size="small"
              v-permit="'EntOrder.Create'"
              v-if="
                appDetail.expiredTime.indexOf('0001-01') == -1 &&
                appDetail.combo &&
                !appDetail.combo.isTrial
              "
              @click="handleServiceRenewal('renew')"
              >续费</el-button
            >
            <el-button
              style="margin-right: 10px"
              size="small"
              v-permit="'DeliveryApp.Domain.Create'"
              v-if="
                appDetail.expiredTime.indexOf('0001-01') == -1 &&
                appDetail.state !== 'expired'
              "
              @click="DomainVisible = true"
              >绑定域名</el-button
            >
            <el-button
              v-if="Domain && appDetail.state !== 'expired'"
              style="margin-right: 10px"
              size="small"
              type="primary"
              v-permit="'DeliveryApp.Domain.List'"
              @click="
                handleDomain(
                  appDetail.domains &&
                    appDetail.domains.length > 0 &&
                    appDetail.domains[0]
                )
              "
              >访问</el-button
            >
          </el-col>
        </div>
        <div class="base_info">
          <el-row>
            <label-item label="版本" :value="appDetail.appVersion"></label-item>
            <label-item
              label="套餐"
              :custom="true"
              v-if="appDetail.combo"
              :value="appDetail.combo.comboName"
            >
              <template v-slot:value>
                <a @click="setShowPackage">{{ appDetail.combo.comboName }}</a>
                <el-tag
                  style="margin-left: 5px"
                  v-if="appDetail.combo.isTrial"
                  type="success"
                  size="mini"
                  >试用</el-tag
                >
              </template>
            </label-item>
            <label-item
              label="开始时间"
              :value="appDetail.createTime | moment"
            ></label-item>
            <label-item
              label="到期时间"
              :value="appDetail.expiredTime | moment"
            ></label-item>
            <label-item
              label="服务商"
              :value="appDetail.marketName"
            ></label-item>
            <label-item
              label="联系人"
              :value="appDetail.marketContactPerson"
            ></label-item>
            <label-item
              label="联系方式"
              :value="appDetail.marketContactPhone"
            ></label-item>
            <label-item
              label="状态"
              :value="fetchAppState(appDetail.state)"
              :style="{
                color: fetchAppState(appDetail.state, true)
              }"
            ></label-item>
            <label-item
              :span="12"
              label="访问域名"
              :custom="true"
              v-permit="'DeliveryApp.Domain.List'"
            >
              <template v-slot:value>
                <template v-if="Domain && appDetail.state !== 'expired'">
                  <div v-for="item in Domain" :key="item.ruleID">
                    <a @click="handleDomain(item.domain)">{{ item.domain }}</a>
                  </div>
                </template>
              </template>
            </label-item>
          </el-row>
        </div>
      </div>

      <el-row style="margin-top: 30px" v-permit="'DeliveryApp.Metrics'">
        <div>
          <h2 class="tit-box">应用运行监控</h2>
          <el-row>
            <el-col :span="7">
              <chart-card
                :loading="Loading"
                title="平均响应时间（ms）"
                :total="queryTog2(requestTimeRange) | NumberFormat"
              >
                <el-tooltip
                  content="平均响应时间，单位毫秒"
                  placement="top"
                  slot="action"
                >
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
                <div>
                  <mini-area :data="queryRangeTog2(requestTimeRange)" />
                </div>
              </chart-card>
            </el-col>
            <el-col :span="7" :offset="1">
              <chart-card
                :loading="Loading"
                title="吞吐率（dps）"
                :total="queryTog2(appRequestRange) | NumberFormat"
              >
                <el-tooltip
                  content="过去一分钟平均每5s的请求次数"
                  placement="top"
                  slot="action"
                >
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
                <div>
                  <mini-area :data="queryRangeTog2(appRequestRange)" />
                </div>
              </chart-card>
            </el-col>
            <el-col :span="7" :offset="1">
              <chart-card
                :loading="Loading"
                title="在线人数"
                :total="queryTog2(onlineNumberRange) | NumberFormat"
              >
                <el-tooltip
                  content="过去5分钟的独立IP数量"
                  placement="top"
                  slot="action"
                >
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
                <div>
                  <mini-bar :data="queryRangeTog2(onlineNumberRange)" />
                </div>
              </chart-card>
            </el-col>
          </el-row>
        </div>
      </el-row>

      <div class="detail_info_box" v-permit="'WarningNotify.List'">
        <div class="tit">预警信息</div>
        <div class="detail_table">
          <public-table
            :loading="Loading"
            :column="warningcolumn"
            :tableData="warningData"
          >
            <template v-slot:atWhen="{ row }">
              <div>{{ row.atWhen | moment }}</div>
            </template>
            <template v-slot:handleTime="{ row }">
              <div>{{ timetrans(row.handleTime) }}</div>
            </template>
            <template v-slot:operation="{ row }">
              <el-button
                size="mini"
                type="text"
                v-permit="'WarningNotify.Update'"
                v-if="row.handleStatus == 'waiting'"
                @click="handleMessage(row)"
                >处理</el-button
              >
            </template>
          </public-table>
        </div>
      </div>
    </div>
    <DialogBindingDomain
      v-if="DomainVisible"
      @handleClose="handleCloseDomain"
      :dialogVisible="DomainVisible"
      :Domain="Domain"
      :appID="appID"
    />
    <handle-message
      :eid="eid"
      :messageID="handleMessageID"
      :dialogVisible="showHandleMessage"
      :onSuccess="handleMessageSuccess"
      :onClose="() => (showHandleMessage = false)"
    />
    <DialogServiceRenew
      v-if="ServiceRenewalVisible"
      @handleClose="handleCloseServiceRenewal"
      :dialogVisible="ServiceRenewalVisible"
      :appDetail="appDetail"
    />
    <el-dialog
      width="500px"
      v-if="appDetail.combo"
      :visible.sync="packageShow"
      title="套餐详情"
    >
      <el-row>
        <label-item
          label="套餐名称"
          :value="appDetail.combo && appDetail.combo.comboName"
        ></label-item>
        <label-item label="套餐价格" :custom="true">
          <template v-slot:value>
            {{ appDetail.combo.comboPrice }}元/{{
              useCycle[appDetail.combo.billCycle]
            }}</template
          >
        </label-item>
      </el-row>
      <el-divider content-position="center">套餐指标</el-divider>
      <el-row>
        <template v-for="item in appDetail.combo.items">
          <label-item
            v-if="item"
            :key="item.name"
            :label="item.showName"
            :value="item.value"
          ></label-item>
        </template>
      </el-row>
    </el-dialog>
    <MerchantsInfo
      v-if="isShowMerchantsInfo"
      @handleClose="isShowMerchantsInfo = false"
      :dialogVisible="isShowMerchantsInfo"
      :marketInfo="appDetail"
    />
  </div>
</template>
<script>
import { timetrans } from '@/utils/validate';
import { fetchAppState } from '@/utils/dictionary';
import { errorHandle } from '@/utils/error';
import DialogBindingDomain from '@/components/Dialog/BindingDomain/index.vue';
import DialogServiceRenew from '../components/renew.vue';
import { ChartCard, MiniBar, MiniArea } from '@/components';
import { queryTog2, queryRangeTog2 } from '@/utils/monitorDataUtil';
import HandleMessage from '../../warningInfo/components/handleMessage';
import { getBuyersAppUpVersion } from '@/api/appStore';
import { havePerm } from '../../../utils/auth';
import MerchantsInfo from '@/components/Dialog/MerchantsInfo/index.vue';

const defaultListQuery = {
  page: 1,
  size: 10,
  resourceType: 'deliveryApp'
};
export default {
  name: 'MyOrderInfo',
  components: {
    HandleMessage,
    DialogBindingDomain,
    DialogServiceRenew,
    ChartCard,
    MiniBar,
    MiniArea,
    MerchantsInfo
  },
  data() {
    return {
      isShowMerchantsInfo: false,
      orderType: '',
      packageShow: false,
      types: 'app',
      queryTog2,
      queryRangeTog2,
      timetrans,
      ServiceRenewalVisible: false,
      DomainVisible: false,
      fetchAppState,
      listQuery: defaultListQuery,
      Loading: true,
      appDetail: false,
      appID: this.$route.params.appId,
      Domain: [],
      warningData: [],
      handleMessageID: '',
      showHandleMessage: false,
      useCycle: {
        week: '周',
        month: '月',
        quarter: '季',
        year: '年'
      },
      warningcolumn: [
        {
          prop: 'messageContent',
          label: '预警信息'
        },
        {
          prop: 'atWhen',
          label: '开始时间',
          scopeStatus: true
        },
        {
          prop: 'handleTime',
          label: '处理时间',
          scopeStatus: true
        },
        {
          prop: 'operation',
          label: '操作',
          scopeStatus: true
        }
      ],
      appMonitoringInfo: false,
      requestTimeRange: {},
      appRequestRange: {},
      onlineNumberRange: {},
      isUpgrade: false
    };
  },
  created() {
    this.getEnterpriseAppInfo();
    this.fetchEnterpriseWarningInfo();
    this.fetchBindingDomain();
  },
  computed: {
    eid() {
      return this.$store.state.enterprise.enterpriseInfo.eid;
    }
  },
  methods: {
    setShowPackage() {
      this.packageShow = true;
    },
    handleDomain(domains) {
      if (
        domains &&
        this.appDetail.canVisit &&
        this.appDetail.state === 'serving'
      ) {
        window.open(domains, '_blank');
      } else {
        this.isShowMerchantsInfo = true;
      }
    },
    UpVersion() {
      getBuyersAppUpVersion({
        appID: this.appID
      })
        .then((res) => {
          if (res && res.length > 0) {
            this.isUpgrade = true;
          }
        })
        .catch(() => {
          this.isUpgrade = false;
        });
    },
    handleMessageSuccess() {
      this.showHandleMessage = false;
      this.$message.success('处理异常信息成功');
      this.getEnterpriseAppInfo();
      this.fetchEnterpriseWarningInfo();
    },
    handleMessage(row) {
      this.showHandleMessage = true;
      this.handleMessageID = row.messageID;
    },
    handleServiceRenewal(type) {
      if (this.appDetail.combo.isTrial) {
        return;
      }
      this.orderType = type;
      this.ServiceRenewalVisible = true;
    },
    handleCloseServiceRenewal(next) {
      this.ServiceRenewalVisible = false;
      if (next) {
        this.$message.success('续费成功');
        this.getEnterpriseAppInfo();
      }
    },
    fetchEnterpriseDeilveryAppsMonitoring() {
      if (!havePerm('DeliveryApp.Metrics')) {
        return;
      }
      this.$store
        .dispatch('fetchEnterpriseDeilveryAppsMonitoring', {
          appID: this.appID
        })
        .then((res) => {
          if (res && res.length > 0) {
            this.appMonitoringInfo = res;
            res[0].monitors.map((item) => {
              const { data, monitor_item } = item;
              if (monitor_item === 'request_time') {
                this.requestTimeRange = data;
                // 获取应用平均响应时间监控数据
              }
              if (monitor_item === 'request') {
                this.appRequestRange = data;
                // 获取应用吞吐率监控数据
              }
              if (monitor_item === 'request_client') {
                this.onlineNumberRange = data;
                // 在线人数
              }
            });
          }
          if (this.timers) {
            return null;
          }
          this.timers = setInterval(
            this.fetchEnterpriseDeilveryAppsMonitoring,
            10000
          );
        });
    },
    fetchEnterpriseWarningInfo() {
      if (!havePerm('WarningNotify.List')) {
        return;
      }
      this.$store
        .dispatch(
          'fetchEnterpriseWarningInfo',
          Object.assign(
            {},
            {
              eid: this.eid,
              resourceID: this.appID
            },
            this.listQuery
          )
        )
        .then((res) => {
          this.warningData = res.messages;
          this.Loading = false;
        })
        .catch(() => {
          this.Loading = false;
        });
    },
    handleCloseDomain(updata) {
      this.DomainVisible = false;
      if (updata) {
        this.getEnterpriseAppInfo();
        this.fetchBindingDomain();
      }
    },
    fetchBindingDomain() {
      if (!havePerm('DeliveryApp.Domain.List')) {
        return;
      }
      this.$store
        .dispatch('fetchEnterpriseDeliveryDomains', {
          appID: this.appID
        })
        .then((res) => {
          if (res) {
            this.Domain = res;
          }
        })
        .catch((err) => {
          this.Loading = false;
          errorHandle(err);
        });
    },
    getEnterpriseAppInfo() {
      this.Loading = true;
      this.$store
        .dispatch('getEnterpriseAppInfo', {
          appID: this.appID
        })
        .then((res) => {
          this.Loading = false;
          if (res) {
            this.appDetail = res;
            if (res.status && res.status != 'released') {
              this.fetchEnterpriseDeilveryAppsMonitoring();
            }
          }
        })
        .catch((err) => {
          this.Loading = false;
          errorHandle(err);
        });
    }
  },
  beforeDestroy() {
    clearInterval(this.timers);
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mintit-box {
  margin-bottom: 10px;
}
.tit-box {
  font-size: 18px;
  line-height: 30px;
  margin: 30px 0 20px 0;
}
.cens {
  text-align: center;
  padding: 30px;
  h6 {
    font-weight: 300;
    font-size: 20px;
    text-align: center;
  }
}

.titles {
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  color: #2c3e50;
}

.detail-container {
  width: 80%;
  padding: 20px 20px 20px 20px;
  margin: 20px auto;
}

.operate-container {
  background: #f2f6fc;
  height: 80px;
  margin: -20px -20px 0;
  line-height: 80px;
}

.operate-button-container {
  float: right;
  margin-right: 20px;
}
.status_item {
  display: inline-block;
  min-width: 110px;
  padding: 10px 0;
  .label {
    color: rgb(168, 168, 168);
    margin-bottom: 15px;
  }
  .txt {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/enterpriseApp/details/index.vue